import { render, staticRenderFns } from "./YearlyChart.vue?vue&type=template&id=724fd57a&"
import script from "./YearlyChart.vue?vue&type=script&lang=js&"
export * from "./YearlyChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports